module.exports = __webpack_public_path__ + "img/thumbnail_NileMonitor_j_normal.ef67da54.png";